import React, { useEffect, useState } from "react";
// import SideBar from "../constant_components/Sidebar";
// import { useContext } from "react";
// import { SnackbarContext } from "../constant_components/providers/SnackbarProvider";
import UserProfileCard from "./UserProfileCard";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import axiosClient from "@service/axiosClient";

const UserProfileGrid = () => {
  // const { triggerSnackbar } = useContext(SnackbarContext);
  const [users, setUsers] = useState([]);
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [hasHandledUnauthorized, setHasHandledUnauthorized] = useState(false);

  useEffect(() => {
    // Fetch the list of users from the API
    axiosClient
      .get("/api/users")
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          if (!hasHandledUnauthorized) {
            // triggerSnackbar('You are not authorized to view this page', 'error');
            setIsAuthorized(false);
            setHasHandledUnauthorized(true);
          }
        } else {
          console.error("Failed to fetch users:", error);
        }
      });
  }, [hasHandledUnauthorized]);

  if (!isAuthorized) {
    return <div>Not authorized</div>;
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* <SideBar prop={navBar} /> */}
      <Grid container spacing={3}>
        {users
          .filter((user) => user.worker !== null)
          .map((user) => (
            // console.log(user),
            <Grid item xs={12} sm={6} md={4} lg={3} key={user.id}>
              <UserProfileCard prop={user} isAuthorized={true} />
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

export default UserProfileGrid;
